<template>
  <div class="print-container">
    <div class="printBtnBox">
      <el-button class="printBtn" type="primary" @click="print">打印</el-button>
      <el-button class="printBtn" type="primary" @click="exportWord">导出word</el-button>
    </div>
    
    <!-- 报价单标题 -->
    <div class="printContainer">
      <div class="title">新时达工控技术(杭州)有限公司</div>
      <div class="title">售后维修报价清单</div>
      <!-- 客户信息 -->
      <table class="info-table">
        <tr>
          <td class="label">客户名称：</td>
          <td class="value">
            {{quotation.terminalCustomerName}}
          </td>
          <td class="label">流程单号：</td>
          <td class="value">
            {{quotation.billNo}}
          </td>
        </tr>
        <tr>
          <td class="label">联系人：</td>
          <td class="value">
            {{quotation.customerName}}
          </td>
          <td class="label">联系电话：</td>
          <td class="value">
            {{quotation.phone}}
          </td>
        </tr>
      </table>
    
      <!-- 明细表格 -->
      <table class="detail-table">
        <thead>
          <tr>
            <th width="5%">序号</th>
            <th width="12%">接机快递单号</th>
            <th width="9%">接机日期</th>
            <th width="10%">产品型号</th>
            <th width="10%">条形码</th>
            <th width="10%">检修故障</th>
            <th width="19%">更换配件</th>
            <th width="5%">数量</th>
            <th width="8%">单价</th>
            <th width="12%">应收费用</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in quotation.details" :key="index">
            <td>{{index + 1}}</td>
            <td>
              <!-- 接机快递单号 -->
              {{item.returnCourierNO}}
            </td>
            <td>
              <!-- 接机日期 -->
              {{item.receiveTime ? item.receiveTime.slice(0, 10) : ''}}
            </td>
            <td>
              <!-- 产品型号 -->
              <span class="display-value">{{item.materialName}}</span>
              <el-input v-model="item.materialName" class="table-input"/>
            </td>
            <td>
              <!-- 条形码 -->
              <span class="display-value">{{item.barcode}}</span>
              <el-input v-model="item.barcode" class="table-input"/>
            </td>
            <td>
              <!-- 检修故障 -->
              <span class="display-value">{{item.faultActual}}</span>
              <el-input v-model="item.faultActual" class="table-input"/>
            </td>
            <td>
              <!-- 更换配件 -->
              <span class="display-value">{{item.replacementParts}}</span>
              <el-input v-model="item.replacementParts" type="textarea" class="table-input"/>
            </td>
            <td>
              <!-- 数量 -->
              <span class="display-value">{{item.quantity}}</span>
              <el-input v-model.number="item.quantity" class="table-input" @input="calculateTotal(item)"/>
            </td>
            <td>
              <!-- 单价 -->
              <span class="display-value">{{item.unitPrice}}</span>
              <el-input v-model.number="item.unitPrice" class="table-input" @input="calculateTotal(item)"/>
            </td>
            <td>
              <!-- 应收费用 -->
              {{item.totalPrice}}
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td colspan="9" class="total-label">合计：</td>
            <td class="total-value">{{totalAmount}}</td>
          </tr>
        </tfoot>
      </table>

      <div class="word-item">备注：此价格包含材料费、人工费和快递费。</div>
      <div class="word-item">1.送货地点：贵公司</div>
      <div class="word-item">2.保修期限：质保期内的维修机，整机在原质保期基础上延保3个月；质保期外的维修机，整机在维修出货后延保6个月；配件不单独质保；人为操作不当、进水、进油或其他不可抗拒因素不在保修范围内；</div>
      <div class="word-item">3.付款方式：款到维修发货，电汇结算</div>
      <div class="word-item">4.付款请打我司对公账号：请截图付款凭证给我司售后专员</div>
      <div class="word-item" style="text-indent: 1em;">开票资料如下：</div>
      <div class="word-item" style="text-indent: 3em;">名称：新时达工控技术(杭州)有限公司</div>
      <div class="word-item" style="text-indent: 3em;">纳税人识别号：91330110341884377N</div>
      <div class="word-item" style="text-indent: 3em;">地址、电话：杭州市余杭区闲林街道闲兴路35号4号楼，0571-88683899</div>
      <div class="word-item" style="text-indent: 3em;">银行账号：工行闲林支行1202083509900072279</div>
      <div class="word-item">5.我司通讯信息：电话：0571-88685225；传真：0571-88685775；售后专员：梁彩红；地址：杭州市余杭区闲林镇闲兴路35号4号楼2楼</div>
      <div style="text-align: right; width: 100%;">
        <img src="/img/se/print_sign_stamp.png" width="504" alt="">
      </div>
    
      <!-- 客户确认 -->
      <div class="confirmation" style="padding-top:20px;">
        <div class="confirm-item">
          <div>客户确认回签：</div>
          <div class="signature">
            <checkbox>同意</checkbox>
            <checkbox>不修返还</checkbox>
          </div>
        </div>
        <div class="confirm-btn" style="text-align: right;">
          <div style="margin-right: 170px;">单位（章）/ 确认人:</div>
          <div class="date">_______年____月______日</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "RepairRegistrationPrint",
    data() {
      return {
        quotation: {
          terminalCustomerName: "",
          billNo: "",
          customerName: "",
          phone: "",
          details: [
            {
              returnCourierNO: "",
              receiveTime: "",
              materialName: "",
              barcode: "",
              replacementParts: "",
              faultActual: "",
              quantity: 0,
              unitPrice: 0,
              totalPrice: 0,
            },
          ],
        },
        totalAmount: 0,
      };
    },
    mounted() {
      this.loadData();
    },
    methods: {
      loadData() {
        const ids = JSON.parse(this.$route.query.params);
        this.$http.put("basic", "repairRegistrations/getListByBatch", ids).then((resp) => {
          if (resp.success) {
            const data = resp.data;
            if (!data || data.length === 0) {
              this.$message.error("未查询到数据");
              return;
            }
            // 填充基本信息
            this.quotation.terminalCustomerName = data[0].terminalCustomerName;
            this.quotation.billNo = data[0].billNo;
            this.quotation.customerName = data[0].customerName;
            this.quotation.phone = data[0].consigneeContact;
          
            // 填充明细
            this.quotation.details = data.map(item => ({
              returnCourierNO: item.returnCourierNO,
              receiveTime: item.receiveTime,
              materialName: item.materialName,
              barcode: item.barcode,
              replacementParts: `${item.replacementParts || ""}（包含接机、接机测试、拆机、维修分析、清洗和维修后的带载测试、发货前测试、发货前品质检验、包装等）`,
              faultActual: item.faultActual,
              quantity: item.quantity || 0,
              unitPrice: item.chargedAmount,
              totalPrice: (item.quantity || 0) * (item.chargedAmount || 0),
            }));
          
            // 计算合计
            this.calculateTotalAmount();
          }
        });
      },
      calculateTotal(item) {
        item.totalPrice = (item.quantity || 0) * (item.unitPrice || 0);
        this.calculateTotalAmount();
      },
      calculateTotalAmount() {
        this.totalAmount = this.quotation.details.reduce((sum, item) => sum + (item.totalPrice || 0), 0);
      },
      print() {
        window.print();
        window.close();
      },
      exportWord() {
        // 获取打印容器的内容
        const printContainer = document.querySelector(".printContainer");
        if (!printContainer) {
          this.$message.error("未找到打印内容");
          return;
        }
        
        // 克隆容器以便修改
        const containerClone = printContainer.cloneNode(true);
        
        // 处理图片，转换为Base64
        const images = containerClone.querySelectorAll("img");
        const imagePromises = Array.from(images).map(img => {
          return new Promise((resolve) => {
            if (img.src) {
              // 确保图片路径是完整的
              let imgSrc = img.src;
              if (imgSrc.startsWith("/")) {
                // 相对路径转换为绝对路径
                imgSrc = window.location.origin + imgSrc;
              }
              
              const imgObj = new Image();
              
              // 处理跨域问题
              imgObj.crossOrigin = "Anonymous";
              
              imgObj.onload = () => {
                try {
                  // 创建Canvas并绘制图片
                  const canvas = document.createElement("canvas");
                  const ctx = canvas.getContext("2d");
                  canvas.width = 1010;
                  canvas.height =454;
                  ctx.drawImage(imgObj, 0, 0, canvas.width, canvas.height);
                  
                  // 转换为Base64
                  const base64 = canvas.toDataURL("image/png");
                  img.src = base64;
                } catch (e) {
                  console.error("图片转换失败:", e);
                  // 转换失败时，尝试保留原始图片路径
                }
                resolve();
              };
              
              // 设置超时处理
              setTimeout(() => {
                resolve();
              }, 5000); // 5秒超时
              
              imgObj.src = imgSrc;
            } else {
              resolve();
            }
          });
        });
        
        // 等待所有图片处理完成
        Promise.all(imagePromises).then(() => {
          // 移除所有输入框和编辑元素
          const inputElements = containerClone.querySelectorAll("input[type='text'], textarea, select, .editable-input, .table-input, .el-input, .el-select, .el-checkbox, .el-input__inner, .el-select__input, .el-textarea__inner");
          inputElements.forEach(element => {
            element.remove();
          });
          
          // 确保显示值元素可见
          const displayValues = containerClone.querySelectorAll(".display-value");
          displayValues.forEach(element => {
            element.style.display = "initial";
            element.style.visibility = "visible";
            element.style.opacity = "1";
          });
          
          // 处理图片，确保图片后文字换行
          const images = containerClone.querySelectorAll("img");
          images.forEach(img => {
            // 确保图片是块级元素
            img.style.display = "block";
            img.style.clear = "both";
            img.style.margin = "0 0 10px auto"; // 右对齐
            
            // 在图片后面添加换行，不管是否有兄弟元素
            const br = document.createElement("br");
            img.parentNode.insertBefore(br, img.nextSibling);
          });
          // 创建完整的HTML文档，使用适合Word的格式
          const htmlContent = `
<!DOCTYPE html>
<html>
<head>
  <meta charset="UTF-8">
  <title>售后维修报价清单</title>
  <style>
    /* 全局样式重置 */
    * {
      margin: 0;
      padding: 0;
      box-sizing: border-box;
    }
    
    body {
      font-family: 'SimSun', '宋体', serif;
      margin: 20px;
      line-height: 1.2;
      font-size: 10pt;
    }
    
    /* 打印容器样式 */
    .print-container {
      width: 210mm;
      margin: 0 auto;
      word-break: normal;
      line-height: 1.5;
    }
    
    /* 标题样式 */
    .title {
      text-align: center;
      font-size: 13pt;
      font-weight: bold;
      margin-bottom: 5px;
      line-height: 1.2;
    }
    
    .title:last-child {
      margin-bottom: 10px;
    }
    
    /* 表格样式 */
    .info-table,
    .detail-table {
      width: 99.8%;
      margin: 0 auto;
      border-collapse: collapse;
      margin-bottom: 20px;
      font-size: 10pt;
      line-height: 1.2;
    }
      .info-row{
        display: block;
      }
    .info-row .label{
      width: 15%;
      display: inline-block;
    }
    .info-row .value{
      width: 35%;
      display: inline-block;
    }
    
    .info-table {
      border: none;
      margin-bottom: 0;
      margin-top: 20px;
    }
    
    .info-table th,
    .info-table td {
      border: none;
      background: none !important;
      line-height: 1.2;
      padding: 4px 2px;
      margin: 0;
    }
    
    /* 标签和值样式 */
    .label {
      background: none !important;
      font-weight: bold;
      width: 15%;
      text-align: right;
      line-height: 1.2;
      margin: 0;
    }
    
    .value {
      width: 35%;
      text-align: left;
      line-height: 1.2;
      background: none !important;
      margin: 0;
    }
    
    /* 明细表格样式 */
    .detail-table {
      table-layout: fixed;
      line-height: 1.2;
    }
    
    .detail-table th,
    .detail-table td {
      padding: 5px 1px;
      border: 1px solid #333;
      text-align: center;
      word-wrap: normal;
      word-break: normal;
      font-size: 10pt;
      background: none !important;
      line-height: 1.2;
      margin: 0;
      vertical-align: middle;
    }
    
    .detail-table th {
      font-weight: bold;
    }
    
    /* 合计样式 */
    .total-label {
      font-weight: bold;
      text-align: right;
      background: none !important;
    }
    
    .total-value {
      font-weight: bold;
      color: #f56c6c;
      background: none !important;
    }
    
    /* 文本项目样式 */
    .word-item {
      line-height: 1.5;
    }
    
    /* 确认区域样式 */
    .confirmation {
      padding-top: 20px;
      line-height: 1.5;
    }
    
    .signature {
      margin-left: 80px;
      line-height: 1.5;
    }
    
    .confirm-btn {
      width: 300px;
      text-align: left;
      line-height: 1.5;
    }
      .confirm-btn .date {
        text-align: right;
      }
    
    .el-checkbox {
      margin-right: 10px;
      display: none !important;
    }
    
    .date {
      margin-left: 100px;
      line-height: 1.5;
    }
    
    /* 图片样式 */
    img {
      max-width: 100%;
      height: auto;
      border: none;
      display: block;
      margin: 0 auto;
    }
    
    /* 导出时隐藏的元素 */
    .printBtnBox,
    input,
    textarea,
    select,
    .editable-input,
    .table-input,
    .el-input,
    .el-select,
    .el-checkbox {
      display: none !important;
    }
    
    /* 显示值 */
    .display-value {
      display: initial !important;
      line-height: 1.5;
    }
    
    /* 段落样式 */
    p {
      margin: 0;
      line-height: 1.5;
    }
    
    /* 行内元素样式 */
    span {
      line-height: 1.5;
    }
  </style>
</head>
<body>
  <div class="print-container">
    ${containerClone.outerHTML}
  </div>
</body>
</html>
          `;
          
          // 创建Blob对象
          const blob = new Blob([htmlContent], {
            type: "application/msword",
          });
          
          // 创建下载链接
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = `售后维修报价清单_${this.quotation.billNo || new Date().getTime()}.doc`;
          
          // 触发下载
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
.printBtnBox {
  width: 195mm;
  margin: 0 auto;
  padding: 2mm 0;
  position: fixed;
  top: 0;
  left: -10cm;
  margin-left: 50%;
  background-color: #fff;
  z-index: 999;
}

.print-container {
  padding: 50px 20px 0;
  width: 210mm;
  margin: 0 auto;
  border: 1px solid #ddd;
  word-break: break-all;
}

.title {
  text-align: center;
  font-size: 13pt;
  font-weight: bold;
  margin-bottom: 5px;

  &:last-child {
    margin-bottom: 10px;
  }
}


.info-table,
.detail-table,
.invoice-table {
  width: 99.8%;
  margin: 0 auto;
  border-collapse: collapse;
  margin-bottom: 20px;
  font-size: 10pt;
}

.invoice-table td {
  padding: 8px;
  border: 1px solid #ddd;
}
.info-table {
  border: none;
  margin-bottom: 0;
  margin-top: 20px;
  th, td {
    border: none;
    background: none;
    line-height: 25px;
  }
}
.label {
  font-weight: bold;
  width: 15%;
  text-align: right;
}

.value {
  width: 35%;
  text-align: left;
}

.detail-table {
  table-layout: fixed;
}

.detail-table th,
.detail-table td {
  padding: 5px 1px;
  border: 1px solid #333;
  text-align: center;
  word-wrap: break-word;
  word-break: break-all;
  font-size: 10pt;
  &.total-label {
    font-weight: bold;
    text-align: right;
  }
}
::v-deep .el-input__inner,
::v-deep .el-textarea__inner {
  padding: 1px;
}
.detail-table th {
  font-weight: bold;
}

.total-value {
  font-weight: bold;
  color: #f56c6c;
}

.invoice-title {
  font-weight: bold;
  margin-bottom: 10px;
}
.confirmation {
  padding-top: 20px;
  display: flex;
  flex-direction: column;
  line-height: 30px;
  .signature {
    margin-left: 80px;
  }
  .confirm-btn {
    width: 300px;
    align-self: flex-end;
    .date {
      margin-left: 100px;
    }
  }
}


/* 编辑状态样式 */
.display-value {
  display: none;
}

.editable-input,
.table-input {
  width: 100%;
}
/* 打印样式 */
@media print {
  .print-container {
    padding: 0;
    border: none;
  }
  .editable-input,
  .table-input {
    display: none;
  }
  .display-value {
    display: initial !important;
  }
  .printContainer {
    margin: 0;
    page-break-inside: avoid;
  }
  .printContainer:not(:last-child) {
    page-break-after: always;
  }
  .printBtnBox {
    display: none;
  }
  @page {
    margin: 1cm;
    counter-increment: page;
    @bottom-center {
      content: "第 " counter(page) " 页";
    }
  }
}
</style>